<template>

  <div>

    <!-- NAV BAR SECTION -->
      <nav class="sticky w-full z-40 top-0 " >

      <navBar/>

      </nav>

    <div class="bg-[#e8e6fe] w-full h-screen font-euclid">

         
      
        <div
          v-if="success"
          class=" border w-10/12 mx-auto bg-medalertBlue bg-opacity-10  text-black px-4 py-3 rounded relative"
          role="alert">

              <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
              <span class="">{{ success }}</span>
        </div>

        <div
        v-if="err"
        class=" border w-10/12  mx-auto bg-red  text-white px-4 py-3 mt-6 rounded relative"
        role="alert">

            <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
            <span class="">{{ err }}</span>
        </div>

        
        <div class="flex justify-between mx-20">

          
          <div class="flex flex-col w-3/5">
            
            <div class="py-4 bg-white rounded-md text-left mt-8 h-auto flex flex-col mx-auto w-full">
              <div class="flex">
                  <p class="ml-4 font-medium"> Patient's number: <span class="text-blue-700 ml-1"> {{clientPhone}} </span></p>
                  <p class="ml-4 font-medium"> Gender: <span class="text-blue-700 ml-1"> {{gender}} </span></p>
                  <p class="ml-4 font-medium"> Date of birth: <span class="text-blue-700 ml-1"> {{dob}} </span></p>
              </div>
                <p class="ml-4 font-medium"> Note or diagnosis: <span class="text-blue-700 ml-1"> {{note}}</span></p>
            </div>

            <div class="mt-6 mb-2">
            <h1 class="font-medium text-left">Prescription details </h1>
            </div>

            <div class="bg-white h-auto w-full rounded-md">
              <table class="table w-full text-left mx-auto rounded-md table-auto">
                <thead class="bg-gray-200 py-2 font-light rounded-md">
                  <tr class="text-gray-700" >
                    <th class="px-3 py-2">S/N</th>
                    <th class="px-3 py-2">Drug</th>
                    <th class="px-3 py-2">Dose</th>
                    <th class="px-3 py-2">Duration</th>
                    <th class="px-3 py-2">Start on</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(drug, index) in allPrescription" :key="index">
                    <td class="px-3 py-1">{{index + 1}}</td>
                    <td class="px-3 py-1">{{drug.drugNameObject}}</td>
                    <td class="px-3 py-1"><span v-if="drug.dose">{{drug.dose}}</span> <span v-else>None</span> </td>
                    <td class="px-3 py-1">{{drug.durationObject}} Day(s)</td>
                    <td class="px-3 py-1">{{new Date(drug.startDate).toLocaleDateString()}}</td>
                  </tr>
                 
                </tbody>

              </table>

            </div>
          </div>

          <div class=" w-1.5/5">
            <!-- <div>
            <h1 class="font-medium text-left mb-2 ">Review reminder cost </h1>
            </div> -->

            <div class="flex flex-col bg-white h-96 rounded-xl mx-auto mt-8"> 
              <div class=" bg-gray-50 w-full rounded-t-lg px-6 py-2 ">
                <h1 class="font-medium text-left  ">Review reminder cost </h1>
              </div>
      
              <div class="flex flex-col">
                <div class="flex px-6 font-medium">
                  <div class="mt-4 text-left">
                      <p class="py-2">Unique Sms:</p>
                      <p class="py-2">Number of Pages:</p>
                      <p class="py-2">Cost per Sms:</p>
                      <p class="py-2">Total reminder cost:</p>
                      <p class="py-2">Amount in words: </p>
                  </div>

                  <div class=" mt-4 text-left ml-10 text-medalertBlue ">
                      <p class="py-2">{{reviewInfo.total_number_of_reminder}}</p>
                      <p class="py-2">{{reviewInfo.total_number_of_page}}</p>
                      <p class="py-2">₦ <span>{{reviewInfo.amount_per_page}}</span></p>
                      <p class="py-2 ">₦ <span>{{reviewInfo.total_amount_to_charge}}</span></p>
                      <p class="py-2">{{converter.toWords(parseInt(totalAmount))}} Naira</p>
                  </div>
                </div>

              </div>

             

              <div class=" flex px-6 my-8">

                <div class=" rounded-md text-black bg-white border-2 text-center font-medium hover:bg-medalertOrange hover:text-white">
                  <button @click="handleCancle" class="py-2 px-12 " >Cancel</button>
                </div>

                <div class="">
                  <button :disabled="inactive"
                  :class="inactive ? 'cursor-not-allowed' : ''" 
                  class=" bg-medalertBlue disabled:bg-gray-200 py-2 px-12 rounded-md text-white ml-12 font-medium text-center "  @click.prevent="approveReminder" >
                   Accept
                  </button>
                </div>

              </div>

                
              </div>

           

          </div>

        </div>

    </div>

  </div>
</template>

<script>

import {useRouter} from 'vue-router';
import { ref } from 'vue';
import { useStore } from "vuex";
import axios from 'axios';

let converter = require('number-to-words');

import navBar from '../components/NavBar'
import Loading from "../components/Loading";
export default {

    components:{navBar, Loading},

    setup(){
        const totalAmount = ref('0')
        console.log(totalAmount)

        // const amountToWord = converter.toWords(60)
        // console.log(amountToWord)

        const router = useRouter();
        const store = useStore();

        const isLoading = ref(false);

        const success = ref('');
        const err = ref('');
        const inactive = ref(false);

        const allPrescription = ref([]);
        const reviewInfo = ref({});
        console.log(reviewInfo)
        const clientPhone  = ref('')
        const gender  = ref('')
        const dob  = ref('')
        const note  = ref('')

        const prescribedDrugs = () => {
          allPrescription.value = store.state.prescriptions
        }

        const clientPhoneNumber = () => {
          clientPhone.value = store.state.clientPhone
        }

        const clientGender = () => {
          gender.value = store.state.gender
        }

        const clientDOB = () => {
          dob.value = store.state.dob
        }

        const clientNote = () => {
          note.value = store.state.note
        }

        const allFixedReminders = () => {
          reviewInfo.value = store.state.reminder.data
          totalAmount.value = store.state.reminder.data.total_amount_to_charge
          console.log(totalAmount.value)
        }


        const handleCancle = () => {
        router.push('/add-reminder')
      };


      const approveReminder = async () => {
        try{
          inactive.value = true
          isLoading.value = true;
          const prescriptionId = store.state.reminder.data.id
          const response = await axios.patch(`/api/v1/prescriptions/${prescriptionId}/approve`);
          if (response){
            console.log(response)
            let feedback =  response.data.result.message
            // alert(feedback)
            success.value = feedback
            window.localStorage.dosageDetails = JSON.stringify([]);
            window.localStorage.phoneNumber = JSON.stringify(null);

            setTimeout(() => {
              success.value = "";
              router.push('/dashboard');
              }, 3000);  
            
          } else {
                throw new Error('Could not create reminder')
            }
            isLoading.value = false;
            // inactive.value = false
        } catch(error){
          inactive.value = false
        err.value = error.response?.result?.message ?? "Erorr! create reminder unsuccessful";
        setTimeout(() => {
          err.value = "";
          }, 3000);  
      }
      };


        return{
        allPrescription,
        clientPhone,
        reviewInfo,
        success,
        err,
        isLoading,
        totalAmount,
        inactive,
        gender,
        dob,
        note,
        handleCancle,
        prescribedDrugs,
        clientPhoneNumber,
        allFixedReminders,
        approveReminder,
        clientGender,
        clientDOB,
        clientNote,
        converter
        
      }

    },

    mounted(){
      this.prescribedDrugs();
      this.clientPhoneNumber();
      this.allFixedReminders();
      this.clientGender();
      this.clientDOB();
      this.clientNote();
    }

    

}
</script>

<style>
  
  .table tbody tr:nth-of-type(even) {
    background-color: rgb(249 250 251);
}

</style>